import React from "react";
import { map } from "lodash";
import { FiX } from "react-icons/fi";

import Button from "components/Button";

interface SourceAction {
  onClick?: () => void;
  label?: string;
  onSubmit?: () => void;
  key?: React.Key;
  icon?: React.ReactNode;
}

interface SourceActionsProps {
  actions?: SourceAction[];
  menuTitle?: string;
}

interface SourceActionsState {
  showMenu: boolean;
}

export default class SourceActions extends React.PureComponent<
  SourceActionsProps,
  SourceActionsState
> {
  constructor(props: SourceActionsProps) {
    super(props);

    this.state = {
      showMenu: false,
    };
  }

  render() {
    return (
      <div className="source-actions">
        <Button
          btnClass="actions-menu-btn"
          size="sm"
          color="action"
          name="action"
          onClick={() => this.setState({ showMenu: true })}
        >
          Manage
        </Button>

        {this.state.showMenu && (
          <ul className="source-actions-menu">
            <h4 className="source-menu-title">{this.props.menuTitle}</h4>
            <span
              className="close-icon"
              onClick={() => this.setState({ showMenu: false })}
            >
              <FiX
                size="16px"
                color="#FFFFFF"
                fill={"#FFFFFF"}
                stroke={"#a8adbb"}
                strokeWidth={"1"}
              />
            </span>
            {map(this.props.actions, (action, index) => (
              <li
                key={index}
                onClick={() => {
                  this.setState({ showMenu: false });
                  action.onClick!();
                }}
                className="source-action-menu-item"
              >
                <span className="action-menu-icon" key={action.key}>
                  {action.icon}
                </span>
                {action.label}
              </li>
            ))}
          </ul>
        )}
      </div>
    );
  }
}
